import { INTERCOM_APP_ID } from '@/entrypoint'
import JobDefinitionType from '@/enums/JobDefinitionType'
import UserTypes from '@/enums/UserTypes'
import { type UserProfile } from '@/stores/auth'

type IntercomCustomAttributes = {
  polNumber?: string | null
  orderNumber?: string | null
  jobName?: string | null
  productName?: string | null
  jobFee?: string | null
  orderAmount?: string | null
}

export const useIntercom = () => {
  const formatCustomerData = (customer: UserProfile) => {
    const additionalAttrs: any = {}

    if (customer.company && customer.company.metadata) {
      customer.company.metadata.forEach((metadata: any) => {
        if (metadata.value) {
          additionalAttrs[metadata.key] = true
        }
      })
    }

    const backendUrl = window.lingokingConfig.SHOP_BACKEND_URL

    const profileUrl =
      customer.userType === UserTypes.TYPE_LINGUIST
        ? backendUrl + '/linguists/show/%2Flinguists%2F' + customer.id
        : customer.userType === null
          ? null
          : backendUrl + '/customers/show/%2Fcustomers%2F' + customer.id

    return {
      email: customer.email,
      user_id: customer.id,
      name: customer.firstName + ' ' + customer.lastName,
      userTitle:
        customer.userTitle === 'mr' ? 'Herr' : customer.userTitle === 'mrs' ? 'Frau' : null,
      userCountry: customer.billingAddress && customer.billingAddress.addressCountry,
      userType: customer.userType,
      userProfile: profileUrl,
      companyName:
        customer.userType === UserTypes.TYPE_CUSTOMER_BUSINESS && customer.company
          ? customer.company.name
          : null,
      telephoneNumber: customer.telephone,
      created_at: customer.createdAt,
      ...additionalAttrs
    }
  }

  const setCustomer = (customer: UserProfile) => {
    window.Intercom('update', {
      ...formatCustomerData(customer)
    })
  }

  const setItem = (item: any) => {
    let jobData = {}

    if (item?.jobs) {
      const customerApprovalJob = item.jobs?.find((job: any) => {
        return job.jobDefinition.type === JobDefinitionType.CUSTOMER_APPROVAL
      })

      if (customerApprovalJob) {
        jobData = {
          polNumber: customerApprovalJob.purchaseOrderNumber || null,
          jobName: customerApprovalJob.name || null,
          jobFee: customerApprovalJob.fee || null
        }
      }
    }

    setCustomAttributes({
      ...jobData,
      productName: item?.product.name || null,
      orderNumber: item?.cart?.confirmation?.id,
      orderAmount: item?.partOfInvoice?.totalPrice ? item.partOfInvoice.totalPrice + '€' : null
    })
  }

  const setCustomAttributes = (customAttributes: IntercomCustomAttributes) => {
    window.Intercom('update', {
      ...customAttributes
    })
  }

  const reset = () => {
    window.Intercom('update')

    window.Intercom('shutdown')

    window.Intercom('boot', {
      app_id: INTERCOM_APP_ID
    })
  }

  return { reset, setItem, setCustomer, setCustomAttributes }
}

export default useIntercom
